<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>

    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="请输入你想搜索文字" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>

      <!-- <el-form-item label="地区：">
        <el-select ref="cityBox" v-model="search.region" placeholder="地区">
          <el-option label="全国" value="" />
          <el-option v-for="item in cityList" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item> -->

      <el-form-item label="地区：">
        <el-cascader v-model="selectedRegion" :options="cityOptions" placeholder="全国" clearable />
      </el-form-item>
    </el-form>

    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="id" label="俱乐部ID" width="80" fixed />
      <el-table-column prop="type" label="俱乐部头像" width="auto" min-width="120">
        <template v-slot="scope">
          <div class="flex-box">
            <img :src="scope.row.logo" alt="" class="img-box">
            <div> {{ scope.row.clubName }}</div>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="type" label="是否官方俱乐部" width="120">
        <template v-slot="scope">
          <span> {{ scope.row.isOfficialClub === 1 ? '否' : '是' }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="region" label="地区" width="160" />
      <el-table-column prop="isRecommend" label="是否主推" width="120">
        <template v-slot="scope">
          <span> {{ scope.row.isRecommend === 1 ? '否' : '是' }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="memberNumber" label="成员数量" width="120" />
      <el-table-column prop="eventNumber" label="发起活动次数" width="auto" min-width="120" />
      <el-table-column prop="name" label="俱乐部名称" width="160" />
      <el-table-column prop="slogan" label="Slogan" width="180" />
      <el-table-column prop="leaderName" label="Leader名称" width="100" />
      <el-table-column fixed="right" width="140" label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="handleLook(row)">查看</el-button>
          <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination background class="fixed-below" :page-size="currentPage.limit" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage.current" :total="currentPage.total" layout="total, prev, pager, next, sizes" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

  </div>
</template>
<script>

import { formatDate } from '@/filters';
import Dialog from '@/components/Dialog';
import cityOptions from '@/model/cityCascader';

export default {
  components: { Dialog },
  data() {
    return {
      list: [],
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
      search: {
        region: '',
        name: '',
      },
      // cityList: [],

      cityOptions, selectedRegion: [],

      enter: 0,
      searchSubmitted: {},

    };
  },
  computed: {
  },
  beforeRouteLeave(to, from, next) {
    const list = ['/rugby/list/edit', '/rugby/list/add', '/rugby/list/look'];
    if (!list.includes(to.path)) {
      this.enter = 0;
      this.searchSubmitted = {};
      this.search = {
        region: '',
        name: '',
      };
    }
    next();
  },

  activated() {
    this.enter += 1;
    if (this.enter) {
      this.searchSubmit();
    }
  },

  mounted() {
    this.getList();
    // this.getCity();

    window.addEventListener('scroll', () => {
      // 城市滚动关闭
      this.$refs.cityBox && this.$refs.cityBox.handleClose();
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', null);
  },
  methods: {

    add() {
      this.$router.push({ path: '/rugby/list/add' });
    },
    edit(row) {
      this.$router.push({ path: '/rugby/list/edit', query: { id: row.id } });
    },
    handleLook(row) {
      this.$router.push({ path: '/rugby/list/look', query: { id: row.id } });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },

    getList() {
      this.$Api.rugby.clubList({ ...this.currentPage, ...this.searchSubmitted }).then(res => {
        this.currentPage.total = res.total;
        this.list = res.data;
      });
    },

    // 城市
    // getCity() {
    //   this.$Api.rugby.cityList({}).then(res => {
    //     this.cityList = res;
    //   });
    // },

    searchSubmit() {
      this.searchSubmitted = {};
      Object.keys(this.search).forEach(key => {
        this.searchSubmitted[key] = this.search[key];
      });
      if (this.selectedRegion.length > 0) {
        this.searchSubmitted.region = this.selectedRegion.join(' / ');
      }

      this.getList();
    },
    reset() {
      this.searchSubmitted = {};
      this.search = {
        region: '',
        name: '',
      };
      this.selectedRegion = [];

      this.getList();
    },

    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getList();
    },

  },
};

</script>
<style lang="less" scoped>
.mr30 {
  margin-right: 30px;
}
/deep/.feedback-dialog {
  .txt-cont {
    margin-bottom: 12px;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #494949;
  }
  .error-cont {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    .error-list {
      flex: 1;
      width: 100%;
    }
  }
}

.coach-form {
  .coach-header {
    overflow: hidden;

    width: 50px;
    height: 50px;

    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.el-tag {
  font-size: 14px;
  font-weight: 400;
}
.flex-box {
  display: flex;
  align-items: center;
  height: 104px;
  .img-box {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    margin-right: 16px;
  }
}
</style>
